import { render } from "./ReportDetail.vue?vue&type=template&id=3d916704&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"

import "./ReportDetail.vue?vue&type=style&index=0&id=3d916704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d916704"]])

export default __exports__